import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getFileResult } from '../../../services';
import {
  STATUS_KEYS,
  processingFileResultStatus,
} from '../../../helpers/options';
import PATH from '../../../helpers/routes.json';

import { createErrorNotification } from '../../../utils/createErrorNotification';
import FileProcessingCard from '../../../components/FileProcessingPageCard';

const MatchingResultView = () => {
  const [status, setStatus] = useState(STATUS_KEYS.IDLE);
  const [fileName, setFileName] = useState('');
  const [fileResultUrl, setFileResultUrl] = useState('');

  const { taskId } = useParams();

  const intervalRef = useRef(null);
  const { t } = useTranslation(['matching']);

  useEffect(() => {
    if (!taskId) return;

    const fetchFileResult = async () => {
      try {
        setStatus(STATUS_KEYS.PENDING);

        const response = await getFileResult(taskId);

        if (response?.data?.orig_filename) {
          setFileName(response.data.orig_filename);
        }

        if (
          (response?.data?.status === processingFileResultStatus.SUCCESS &&
            response?.data?.file_url) ||
          response?.data?.status === processingFileResultStatus.FAILURE
        ) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;

          setFileName(response?.data?.orig_filename || '');
          setFileResultUrl(response?.data?.file_url);

          setStatus(
            response.data.status === processingFileResultStatus.FAILURE
              ? STATUS_KEYS.REJECTED
              : STATUS_KEYS.RESOLVED,
          );
        }
      } catch (error) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setStatus(STATUS_KEYS.REJECTED);
        createErrorNotification();
      }
    };

    fetchFileResult();

    intervalRef.current = setInterval(fetchFileResult, 3000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [taskId]);

  return (
    <FileProcessingCard
      status={status}
      pendingText={
        t('The matching of the file is in progress', {
          fileName: fileName ? ` "${fileName}"` : '',
        }) + '...'
      }
      resolvedText={
        t('The matching of the file is complete', {
          fileName: fileName ? ` "${fileName}"` : '',
        }) + '!'
      }
      errorText={
        t('An error occurred during the matching of the file', {
          fileName: fileName ? ` "${fileName}"` : '',
        }) + '.'
      }
      fileResultUrl={fileResultUrl}
      goBackText={t('Return to the Matching page')}
      goBackUrl={PATH.functions.tabs.matching}
    />
  );
};

export default MatchingResultView;
